export const NAV_COMPONENTS = {
	themeToggle: 'ThemeToggle',
	searchPublicCoursesDialog: 'SearchPublicCoursesDialog',
	logoutDialog: 'LogoutDialog',
} as const

export type NavComponentName =
	(typeof NAV_COMPONENTS)[keyof typeof NAV_COMPONENTS]

export function isThemeToggleComponent(
	component?: string,
): component is typeof NAV_COMPONENTS.themeToggle {
	return component === NAV_COMPONENTS.themeToggle
}

export function isSearchDialogComponent(
	component?: string,
): component is typeof NAV_COMPONENTS.searchPublicCoursesDialog {
	return component === NAV_COMPONENTS.searchPublicCoursesDialog
}

export function isLogoutNavigationItem(item: {
	href?: string
	form?: boolean
	component?: string
}): boolean {
	return (
		item.href === '/logout' ||
		Boolean(item.form) ||
		item.component === NAV_COMPONENTS.logoutDialog
	)
}
